export const groupMemberTabUrlKey = 'members';
export const groupHubUrlKey = 'group';
export const groupHubMemberFolderUrlKey = 'member';
export const groupHubOwnerFolderUrlKey = 'owner';
export const groupHubDeletedFolderUrlKey = 'deleted';
